module.exports = __webpack_public_path__ + "static/img/logo04.81ab34dd.png";